import { FileHeart } from "lucide-react";
import { READY_DRAFTS } from "../../data/readyDrafts";

const USED_KEY = "npc_used_drafts";
const readUsed = () => {
    try {
        return JSON.parse(localStorage.getItem(USED_KEY) || "[]");
    } catch {
        return [];
    }
};
export const markDraftUsed = (id) => {
    localStorage.setItem(USED_KEY, JSON.stringify([...new Set([...readUsed(), id])]));
};

export const ReadyDrafts = ({ onUse }) => {
    const used = readUsed();
    const drafts = READY_DRAFTS.filter((d) => !used.includes(d.id));
    if (!drafts.length) return null;
    return (
        <div data-testid="ready-drafts" className="mt-6 rounded-2xl border border-sky-400/25 bg-sky-500/5 p-5">
            <p className="flex items-center gap-2 text-sm font-semibold text-sky-300">
                <FileHeart className="h-4 w-4" /> Ready-made drafts
            </p>
            <p className="mt-1 text-xs text-slate-300/55">
                Written for you. Load it, look it over, then publish.
            </p>
            <div className="mt-4 flex flex-wrap gap-3">
                {drafts.map((d) => (
                    <button
                        key={d.id}
                        type="button"
                        data-testid={`use-draft-${d.id}`}
                        onClick={() => onUse(d)}
                        className="flex items-center gap-3 rounded-xl border border-blue-500/25 bg-[#070e1c] p-2 pr-4 text-left transition-[background-color,transform] duration-200 hover:bg-blue-500/10 active:scale-[0.98]"
                    >
                        <img src={d.cover_image_url} alt="" className="h-12 w-12 rounded-lg object-cover" />
                        <span className="text-sm text-blue-50">{d.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};
